/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MeetingsTeamsOralUnwindParams } from './meetingsTeamsOralUnwindParams';

/**
 * Request model for Teams oral exam transcript-or-unwind job
 */
export interface RunMeetingsTeamsOralUnwindJobRequest {
  type: 'meetings_teams_oral_unwind';
  params: MeetingsTeamsOralUnwindParams;
  allowOverlappingJobs?: boolean;
}
